const uiSchema = () => ({
  password: {
    "ui:widget": "password",
  },
});

export default uiSchema;
